<template>
    <div class="box" style="min-height: 200px">
        <div class="box-body">
            <ul id="sales-tree" data-widget="tree">
                <li class="treeview">
                    <a href="#"><i class="fa fa-folder"></i> {{ project.name }}</a>
                    <div class="btn-group">
                        <button class="btn btn-xs btn-link" @click=edit(project)><i class="fa fa-pencil"></i> edit</button>
                        <button class="btn btn-xs btn-link" @click=add(project)><i class="fa fa-plus"></i> add <b>General manager</b></button>
                    </div>
                    <ul class="treeview-menu">
                        <li class="treeview" v-for="(gm, gmKey) in project.child" :key="gmKey">
                            <a href="#"><i class="fa fa-folder"></i> {{ gm.name }}</a>
                            <div class="btn-group">
                                <button class="btn btn-xs btn-link" @click=edit(gm)><i class="fa fa-pencil"></i> edit</button>
                                <button class="btn btn-xs btn-link" @click="remove(project, gmKey)"><i class="fa fa-times"></i> remove</button>
                                <button class="btn btn-xs btn-link" @click=add(gm)><i class="fa fa-plus"></i> add <b>Sales manager</b></button>
                            </div>
                            <ul class="treeview-menu">
                                <li class="treeview" v-for="(sm, smKey) in gm.child" :key="smKey">
                                    <a href="#"><i class="fa fa-folder"></i> {{ sm.name }}</a>
                                    <div class="btn-group">
                                        <button class="btn btn-xs btn-link" @click=edit(sm)><i class="fa fa-pencil"></i> edit</button>
                                        <button class="btn btn-xs btn-link" @click="remove(gm, smKey)"><i class="fa fa-times"></i> remove</button>
                                        <button class="btn btn-xs btn-link" @click=add(sm)><i class="fa fa-plus"></i> add <b>Sales coordinator</b></button>
                                    </div>
                                    <ul class="treeview-menu">
                                        <li class="treeview" v-for="(sc, scKey) in sm.child" :key="scKey">
                                            <a href="#"><i class="fa fa-folder"></i> {{ sc.name }}</a>
                                            <div class="btn-group">
                                                <button class="btn btn-xs btn-link" @click=edit(sc)><i class="fa fa-pencil"></i> edit</button>
                                                <button class="btn btn-xs btn-link" @click="remove(sm, scKey)"><i class="fa fa-times"></i> remove</button>
                                                <button class="btn btn-xs btn-link" @click=add(sc)><i class="fa fa-plus"></i> add <b>Sales executive</b></button>
                                            </div>
                                            <ul class="treeview-menu">
                                                <li class="treeview" v-for="(se, seKey) in sc.child" :key="seKey">
                                                    <a href="#"><i class="fa fa-folder"></i> {{ se.name }}</a>
                                                    <div class="btn-group">
                                                        <button class="btn btn-xs btn-link" @click=edit(se)><i class="fa fa-pencil"></i> edit</button>
                                                        <button class="btn btn-xs btn-link" @click="remove(sc, seKey)"><i class="fa fa-times"></i> remove</button>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <pop-alert
            :show=alertShow
            :title=alertTitle
            button=Yes
            @onModalClick="onClickModal"
            @onModalHide="alertShow = false">
            <template v-slot:body>
                <h4>Remove {{ current.name }} ?</h4>
            </template>
        </pop-alert>

        <pop-alert
            :show=formShow
            title="User form"
            button=Save
            @onModalClick="onClickSave"
            @onModalHide="formShow = false">
            <template v-slot:body>
                <h4>User name</h4>
                <input type="text" v-model="name" class="form-control" placeholder="Name"/>
            </template>
        </pop-alert>
    </div>
</template>

<script>
    import PopAlert from './Modal/Alert'
    import axios from 'axios'
    import { apiRouter } from '../router/api-routing.js'
    import { isLoggedIn, getIdToken, removeToken, getDataToken, getHeaderToken } from '../user/token.js'


    export default {
        name: 'Structure',
        props: ['page'],
        data: () => ({
            alertShow: false,
            formShow: false,
            alertTitle: 'Warning',
            removeNumber: 0,
            isEdit: false,
            project: {},
            name: '',
            parentOfChild: null,
            childIndex: null,
            current: {},
            ID: '20',
            structureData: []
        }),
        components: {
            PopAlert
        },
        methods: {
            onClickModal() {
                this.parentOfChild.child.splice(this.childIndex, 1)
                this.alertShow = false
            },
            onClickSave() {
                this.formShow = false
                this.current.name = this.name
                if (this.parentOfChild && this.parentOfChild.child) {
                    this.parentOfChild.child.push(this.current)
                }
                this.initialize()
            },
            remove(parent, index) {
                this.current = parent.child[index]
                this.parentOfChild = parent
                this.alertShow = true
            },
            add(val) {
                this.parentOfChild = val
                this.current = {}
                this.formShow = true
                this.isEdit = false
            },
            edit(val) {
                this.parentOfChild = null
                this.current = val
                this.isEdit = true
                this.formShow = true
            },
            initialize() {
                console.log('Reinitialize ajax request')
            },
            getStructure(){
                axios.get(apiRouter().sales_structure + this.ID, header)
                .then(function (response){
                console.log(response);
                if(response.status === 200){
                    this.structureData = response.data.data;
                    let temp = [];
                    for(var i = 0; i < response.data.length; i++){

                        //console.log("abc " + response.data[i].role_id);
                        temp.push(response.data[i]);
                    }
                    console.log("STR " + response.data.data);

                } else {
                    console.log("not 200");
                }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        watch: {
            project(val) {
                this.initialize();
            }
        },
        mounted() {
            var fakeData = {
                id: 1982,
                name: 'Sample project',
                child: [
                    {
                        id: 9182,
                        name: 'General manager 1',
                        child: [
                            {
                                id: 8712,
                                name: 'Sales manager 1',
                                child: []
                            },
                            {
                                id: 8713,
                                name: 'Sales manager 2',
                                child: [
                                    {
                                        id: 7281,
                                        name: 'Sales coordinator 1',
                                        child: [
                                            {
                                                id: 7281,
                                                name: 'Sales executive 1'
                                            },
                                            {
                                                id: 7283,
                                                name: 'Sales executive 2'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: 9183,
                        name: 'General manager 2',
                        child: []
                    }
                ]
            }

            this.project = fakeData;

            this.$root.page = this.page;
            var tree = $('#sales-tree');
            var options = $.extend({}, {
                accordion   : false,
                tree        : '.tree',
                treeview    : '.treeview',
                treeviewMenu: '.treeview-menu',
                open        : '.menu-open, .active',
                li          : 'li',
                data        : '[data-widget="tree"]',
                active      : '.active'
            }, tree.data());
            tree.tree(options);
            tree.data('lte.tree').options = $.extend(tree.data('lte.tree').options, options);
            var ClassName = {
                open: 'menu-open',
                tree: 'tree'
            };
            tree.data('lte.tree').toggle = function(link, event) {
                var treeviewMenu = link.nextAll(this.options.treeviewMenu);
                var parentLi     = link.parent();
                var isOpen       = parentLi.hasClass(ClassName.open);

                if (!parentLi.is(this.options.treeview)) {
                  return;
                }

                if (!this.options.followLink || link.attr('href') === '#') {
                  event.preventDefault();
                }

                if (isOpen) {
                  this.collapse(treeviewMenu, parentLi);
                } else {
                  this.expand(treeviewMenu, parentLi);
                }
            };
        }
    }
</script>


<style>
    #sales-tree {
        list-style-type: none;
    }
    #sales-tree .treeview > a > .fa.fa-folder {
        margin-right: 4px;
    }
    #sales-tree .treeview.menu-open > a > .fa.fa-folder {
        margin-right: 2px;
    }
    #sales-tree .treeview.menu-open > a > .fa.fa-folder:before {
        content: "\f07c";
    }
    #sales-tree li>.btn-group {
        visibility: hidden;
    }
    #sales-tree li:hover > .btn-group {
        visibility: visible;
    }
    #sales-tree li > a {
        display: inline-block;
        vertical-align: middle;
        border-bottom: 1px dotted transparent;
        margin-right: 16px;
    }
    #sales-tree li > a:hover {
        border-bottom: 1px dotted #d5d5d5;
    }

</style>
